import { useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { id: "chi-sono", label: "Chi sono" },
  { id: "trattamenti", label: "Trattamenti" },
  { id: "come-funziona", label: "Come funziona" },
  { id: "faq", label: "FAQ" },
  { id: "recensioni", label: "Recensioni" },
  { id: "contatti", label: "Contatti" },
];

export function scrollToSection(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 backdrop-blur-xl bg-bone/85 border-b border-pine/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              onClick={go(l.id)}
              className="text-sm font-medium text-moss hover:text-pine transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="header-cta-button"
            onClick={go("contatti")}
            className="rounded-full bg-pine text-bone text-sm font-semibold px-6 py-2.5 hover:bg-terracotta transition-colors duration-300"
          >
            Prenota ora
          </button>
        </nav>
        <button
          data-testid="mobile-menu-button"
          className="md:hidden text-pine"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} strokeWidth={1.5} /> : <Menu size={24} strokeWidth={1.5} />}
        </button>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="md:hidden border-t border-pine/10 bg-bone px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a key={l.id} href={`#${l.id}`} data-testid={`mobile-nav-link-${l.id}`} onClick={go(l.id)} className="text-base font-medium text-pine">
              {l.label}
            </a>
          ))}
          <button data-testid="mobile-cta-button" onClick={go("contatti")} className="rounded-full bg-pine text-bone text-sm font-semibold px-6 py-3 w-full">
            Prenota ora
          </button>
        </nav>
      )}
    </header>
  );
}
